'use client';

import { c as _c } from "react/compiler-runtime";
import { ThemeProvider, type Theme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import type { ReactNode } from 'react';
import { theme } from '../../theme';

// Export breakpoints from the final theme to match pre-migration behavior
export const breakpoints = theme.breakpoints;
export const NerdWalletThemeProvider = t0 => {
  const $ = _c(8);
  let merge;
  let props;
  if ($[0] !== t0) {
    ({
      merge,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = merge;
    $[2] = props;
  } else {
    merge = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== merge) {
    t1 = deepmerge(theme, merge);
    $[3] = merge;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <ThemeProvider theme={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export * from '../../theme';